import { all } from "redux-saga/effects";

import { saga as obterGeometriaFotos360Saga } from "./actions/obterGeometriaFotos360";
import { saga as obterDetalheFoto360Saga } from "./actions/obterDetalheFoto360";

export default all([obterGeometriaFotos360Saga, obterDetalheFoto360Saga]);
